// SCRM 模块 - 客户关系管理
const state = {
    token: '',
    
}

const getters = {
}

const mutations = {
    SET_TOKEN(state, token) {
        state.token = token || ''
    }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js